import { createGlobalStyle } from 'styled-components'
import { PancakeTheme } from '@pancakeswap/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Kanit', sans-serif;
  }
  body {
    background: #FF4444; /* 明亮的红色背景，不要黑色 */
    background-color: ${({ theme }) => theme.colors.background};
    min-height: 100vh;

    img {
      height: auto;
      max-width: 100%;
    }
  }
  /* 背景为白色的输入框内字体改为黑色 */
  input.token-amount-input,
  .token-amount-input {
    color: #000000;
  }
  input.token-amount-input::placeholder,
  .token-amount-input::placeholder {
    color: #666666;
  }
`

export default GlobalStyle
